















































































































import { Component, Vue } from 'vue-property-decorator';
import { MemberContactsService } from '../services/MemberContactsService';
import { MembersResult } from '../models/membersResult';
import { VoOfficeResult } from '../models/voOfficeResult';
import { Point } from '../models/point';
import { Position } from '../models/position';
import { Config } from '@/utils/Config';
import { Consoler } from '@/utils/Consoler';
import { EventBus } from '../utils/EventBus';
import { Member } from '../models/member';
import { VoOffice } from '../models/voOffice';
import Contact from '@/components/Contact.vue';
import { RegionOfficeResult } from '@/models/regionOfficeResult';
import { VoOffices } from '@/models/voOffices';

enum MemberType {
  Elected = 'elected',
  VoOffice = 'office',
  // Inspectors = 'inspectors',
  // Economist = 'economist',
}

enum RegionOffices {
  South = 11,
  West = 24,
  East = 14,
}

@Component({
  components: {
    Contact,
  },
})
export default class Contacts extends Vue {
  $refs!: {
    refMember: HTMLDivElement;
  };
  private selectedPosition: Position | null = null;
  private membersResult: MembersResult | null = null;
  private voOfficeResult: VoOfficeResult | null = null;
  private filteredMembers: Member[] = [];
  private voOffices: VoOffice[] | null = [];
  private contactsIsLoading: boolean = false;
  private errorLoadingMembers: boolean = false;
  private errorNoAreaFound: boolean = false;
  private memberTypes = MemberType;
  private selectedMemberType: MemberType = MemberType.Elected;
  private fakePostion: boolean = false;

  private get voToExclude(): string {
    return VoOffices.VoForSkogsEkonomer;
  }

  private mounted(): void {
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    Consoler.debugLog(params.get('name'));

    this.loadMembers(this.selectedPosition);

    EventBus.$on(
      Config.MapRegionOfficeSelectedEvent,
      this.onSelectedRegionOffice
    );

    EventBus.$on(Config.MapPositionSelectedEvent, this.onSelectedMapPosition);
  }

  private beforeDestroy(): void {
    EventBus.$off(
      Config.MapRegionOfficeSelectedEvent,
      this.onSelectedRegionOffice
    );

    EventBus.$off(Config.MapPositionSelectedEvent, this.onSelectedMapPosition);
  }

  private onSelectedMemberType(type: MemberType): void {
    this.selectedMemberType = type;

    if (this.selectedMemberType === MemberType.VoOffice) {
      this.fakePostion = false;
      this.loadVoOffices();
    } 
    // else if (this.selectedMemberType === MemberType.Economist) {
    //   if (this.membersResult != null && this.membersResult.economists.length) {
    //     this.fakePostion = true;
    //     this.filterMembers();
    //   } else {
    //     this.loadMembersForVo('452');
    //   }
    // } 
    else {
      if (this.membersResult == null) {
        this.loadMembers(this.selectedPosition);
      } else {
        this.filterMembers();
      }
    }
  }

  private onSelectedMapPosition(position: Position | null) {
    if (this.selectedMemberType === MemberType.VoOffice) {
      return;
    }

    this.selectedPosition = position;

    this.loadMembers(position);
  }

  private onSelectedRegionOffice(regionOffice: RegionOfficeResult): void {
    this.onSelectedVoOffice(this.regionOfficeClick(regionOffice.objectId));

    if (regionOffice.position) {
      this.setMapPoint(regionOffice.position);
    }
  }

  private onSelectedVoOffice(type: VoOffice): void {
    Consoler.debugLog('Click slecter vo' + type.voNumber);
    // this.selectedMemberType = MemberType.Inspectors;
    this.loadMembersForVo(type.voNumber);
  }

  private loadMembersForVo(voNumber): Promise<any> {
    this.membersResult = null;
    this.contactsIsLoading = true;
    this.errorLoadingMembers = false;
    this.errorNoAreaFound = false;
    this.voOffices = null;
    this.fakePostion = true;

    Consoler.debugLog('the number is ' + voNumber);

    return MemberContactsService.getMembersForVo(voNumber)
      .then((response) => {
        const result: MembersResult = response && response.data;
        Consoler.debugLog(
          'Successfully loaded membersVO from API',
          response.data
        );
        this.membersResult = result;
      })
      .catch((error) => {
        Consoler.debugWarn(
          'Failed to fetch membersVO from API',
          error.response
        );
        if (error && error.response && error.response.status === 404) {
          this.errorNoAreaFound = true;
        } else {
          this.errorLoadingMembers = true;
        }
      })
      .finally(() => {
        this.filterMembers();
        this.contactsIsLoading = false;
        this.$nextTick(() => {
          const top = this.$refs.refMember.offsetTop - 300;
          window.scrollTo(0, top);
        });
      });
  }

  private loadVoOffices() {
    this.contactsIsLoading = true;
    this.errorLoadingMembers = false;
    this.errorNoAreaFound = false;
    return MemberContactsService.getVoOffices()
      .then((response) => {
        const result: VoOfficeResult = response && response.data;
        this.voOfficeResult = result;
        Consoler.debugLog('OfficeResult = ' + response.data);
      })
      .catch((error) => {
        Consoler.debugWarn('Failed to fetch offices from API', error.response);
        if (error && error.response && error.response.status === 404) {
          this.errorNoAreaFound = true;
        } else {
          this.errorLoadingMembers = true;
        }
      })
      .finally(() => {
        this.filterMembers();
        EventBus.$emit(Config.MapClearPointsEvent);
        this.contactsIsLoading = false;
      });
  }

  private loadMembers(position): Promise<any> {
    Consoler.debugLog('StartLoding Member');

    if (position === null) {
      Consoler.debugLog('Null feature, setting members to empty.');
      this.membersResult = null;
      this.filterMembers();
      return Promise.resolve();
    }

    this.contactsIsLoading = true;
    this.errorLoadingMembers = false;
    this.errorNoAreaFound = false;
    this.membersResult = null;
    this.setMapPoint(position);

    return MemberContactsService.getMembersForArea(position)
      .then((response) => {
        const result: MembersResult = response && response.data;
        Consoler.debugLog('Successfully loaded members from API', result);
        this.membersResult = result;
      })
      .catch((error) => {
        Consoler.debugWarn('Failed to fetch members from API', error.response);
        if (error && error.response && error.response.status === 404) {
          this.errorNoAreaFound = true;
        } else {
          this.errorLoadingMembers = true;
        }
      })
      .finally(() => {
        this.filterMembers();
        this.contactsIsLoading = false;
        this.$nextTick(() => {
          const top = this.$refs.refMember.offsetTop - 300;
          window.scrollTo(0, top);
        });
      });
  }

  private setMapPoint(pos: Position) {
    EventBus.$emit(Config.MapClearPointsEvent);

    const point: Point = {
      coordinates: [pos.longitude, pos.latitude],
      projection: Config.MapProjection,
    };
    EventBus.$emit(Config.MapSetPointEvent, point);
  }

  private regionOfficeClick(regionOfficeId: number) {
    const voOffice: VoOffice = {
      voNumber: '',
      voName: '',
      voAddress: '',
    };

    switch (regionOfficeId) {
      case RegionOffices.South:
        voOffice.voNumber = '960';
        break;
      case RegionOffices.East:
        voOffice.voNumber = '970';
        break;
      case RegionOffices.West:
        voOffice.voNumber = '980';
    }

    return voOffice;
  }

  private filterMembers() {
    switch (this.selectedMemberType) {
      // case MemberType.Inspectors:
      //   if (this.membersResult != null) {
      //     this.filteredMembers = this.membersResult.inspectors.filter(
      //       (x) => x.voNumber !== VoOffices.VoForSkogsEkonomer
      //     );
      //   }
      //   this.voOffices = [];
      //   EventBus.$emit(Config.MapShowVoOrSboLayerEvent, true);
      //   break;
      case MemberType.Elected:
        if (this.membersResult != null) {
          const titleOrder = [
            this.$t('contacts.electedTypes.president').toString(),
            this.$t('contacts.electedTypes.viceChairman').toString(),
            this.$t('contacts.electedTypes.commissioner').toString(),
            this.$t(
              'contacts.electedTypes.electionCommitteeConvening'
            ).toString(),
            this.$t('contacts.electedTypes.electionCommitteeMember').toString(),
          ];

          this.filteredMembers = this.membersResult.elected.sort((a, b) => {
            const sortOrderA = titleOrder.findIndex(
              (title) => a.title === title
            );
            const sortOrderB = titleOrder.findIndex(
              (title) => b.title === title
            );

            if (sortOrderB === -1) {
              return -1;
            } else {
              return sortOrderA - sortOrderB;
            }
          });
        }
        this.voOffices = [];
        EventBus.$emit(Config.MapShowVoOrSboLayerEvent, false);
        break;
      case MemberType.VoOffice:
        this.filteredMembers = [];
        if (this.voOfficeResult != null) {
          this.voOffices = this.voOfficeResult.voOffices;
        }
        this.selectedPosition = null;
        EventBus.$emit(Config.MapShowVoOrSboLayerEvent, true);
        break;
      // case MemberType.Economist:
      //   if (
      //     this.membersResult != null &&
      //     this.membersResult.economists.length > 0
      //   ) {
      //     this.filteredMembers = this.membersResult.economists;
      //   }
      //   this.voOffices = [];
      //   EventBus.$emit(Config.MapShowVoOrSboLayerEvent, true);
      //   break;
    }
  }
}
